module.exports = __webpack_public_path__ + "img/logo.c6f15cbd.png";